module.exports = __webpack_public_path__ + "static/media/trash.c1f250b0.svg";